import { ArrowUpRight } from 'lucide-react';
import { CacLink } from '@/components/buttons/CacLink.tsx';
import CopyButton from '@/components/buttons/CopyButton.tsx';
import { BookingSummaryVm } from '@/features/dashboard/bookingChanges/types/BillViewModel.ts';
import { DetailsLink } from '@/features/dashboard/bookingChanges/routes/detailsLinks.ts';
import { InfoCardHeader } from '@/components/ui/InfoCard.tsx';
import StatusDot from '@/components/ui/StatusDot.tsx';
import { BookingStatus } from '@/types/BookingStatus.ts';
import { getBookingStatusLabel } from '@/features/dashboard/bookingChanges/types/BillViewModel.utils.ts';
import { bookingStatusTone } from '@/features/dashboard/bookingChanges/components/bookingDetails/bookingHeaderPresentation.ts';
import { formatFullDateTime } from '@/features/dashboard/bookingChanges/utils/formatters.ts';

interface BookingStateHeaderProps {
  summary: BookingSummaryVm;
  /** Dokąd prowadzi kod rezerwacji; adres zna rodzic, nie karta. */
  bookingLink: DetailsLink;
}

/** Nagłówek karty stanu: kod rezerwacji jako odnośnik, obok wyjazd i termin, pod nimi data utworzenia. */
const BookingStateHeader = ({
  summary,
  bookingLink,
}: BookingStateHeaderProps) => (
  <InfoCardHeader
    title="Stan rezerwacji"
    // Tylko anulowana: kropka „Potwierdzona” na każdej karcie byłaby szumem.
    aside={
      summary.bookingStatus === BookingStatus.CANCELLED && (
        <StatusDot
          className="text-[13px]"
          tone={bookingStatusTone[summary.bookingStatus]}
          label={getBookingStatusLabel(summary.bookingStatus)}
        />
      )
    }
  >
    <div className="mt-[7px] flex flex-wrap items-baseline gap-x-2 gap-y-1">
      <span className="inline-flex items-center gap-0.5">
        <CacLink
          to={bookingLink.to}
          params={bookingLink.params}
          className="text-[15px] font-bold text-info-300 [&>svg]:size-4"
        >
          {summary.bookingCode}
          <ArrowUpRight aria-hidden />
        </CacLink>
        {/* Kwadrat 26 px jest wyższy od linii kodu — bez ujemnego marginesu
            rozpychałby nagłówek. */}
        <span className="-my-1 inline-flex">
          <CopyButton value={summary.bookingCode} />
        </span>
      </span>
      <span className="text-[13px] text-neutral-500">
        {`${summary.tourName} · ${summary.dateRangeLabel}`}
      </span>
    </div>
    <p className="mt-1 text-[13px] tabular-nums text-neutral-500">
      {`Utworzona ${formatFullDateTime(summary.createdAt)}`}
    </p>
  </InfoCardHeader>
);

export default BookingStateHeader;
